module.exports = "../../../../platform/assets/pageMainIcon/simple_baobiaochaxunlei2.svg";